import React, { useEffect, useState } from "react";
import StepsComponent from '../../components/common/steps';
import { addDays, dateFormat } from "../../utils/utils";
import { useForm } from "react-hook-form";
import InputComponent from '../../components/common/inputComponent';
import { DevTool } from "@hookform/devtools";
import AddButtonSection from '../../components/common/AddButtonSection';
import InputPrimaryComponents from '../../components/common/inputPrimaryComponents';
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import _ from "lodash";
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";

export default function PostSurgeryFollowUp({ patientVisitId }) {
  const {
    control,
    formState: { errors, dirtyFields },
    setValue,
    watch,
    reset,
    handleSubmit,
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [dataExist, setDataExist] = React.useState(false);
  const [initialData, setInitialData] = useState();
  const onSubmit = async (data) => {
    if (loading) return;
    setLoading(true);
    [
      "date_of_surgery",
      "seventh_day_follow_up",
      "fourteenth_day_follow_up",
      "fortyth_day_follow_up",
    ].forEach((item) =>
      data[item] ? (data[item] = dateFormat(data[item])) : data[item]
    );
    if (data?.diet_given) {
      data.diet_given = data?.diet_given === "yes" ? true : false;
    }
    if (data?.medication_given) {
      data.medication_given = data?.medication_given === "yes" ? true : false;
    }
    data.patient_visit_id = patientVisitId;
    const finalData = {};
    Object.entries(data).forEach(([key, value]) => {
      if (value) finalData[key] = value;
    });
    await commonPostApi(
      dataExist
        ? API_ENDPOINTS.EDIT_POST_SURGERY_FOLLOWUP_DETAILS
        : API_ENDPOINTS.ADD_POST_SURGERY_FOLLOWUP_DETAILS,
      finalData
    )
      .then((data) => {
        if (data?.data) {
          showToast(
            TOAST_TYPE.SUCCESS,
            dataExist
              ? FEATURE_MSG.EXAMINATION.FOLLOWUP_UPDATED
              : FEATURE_MSG.EXAMINATION.FOLLOWUP_ADDED
          );
          reset({
            date_of_surgery: "",
            surgery_details: "",
            treatment_summary: "",
            seventh_day_follow_up: "",
            fourteenth_day_follow_up: "",
            fourteenth_comments: "",
            fortyth_day_follow_up: "",
            fortyth_day_comments: "",
            fortyth_date: "",
            final_status: "",
            seventh_day_comments: "",
            final_status_comments: "",
            medication: "",
            diet: "",
          });
          init();
          setLoading(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoading(false);
      });
  };


  const resetAllFields = () => {
    reset({
      date_of_surgery: "",
      surgery_details: "",
      treated_by: "",
      treatment_summary: "",
      seventh_day_follow_up: "",
      fourteenth_day_follow_up: "",
      fourteenth_comments: "",
      fortyth_day_follow_up: "",
      fortyth_day_comments: "",
      fortyth_date: "",
      final_status: "",
      seventh_day_comments: "",
      final_status_comments: "",
      medication: "",
      diet: "",
    });
  };

  const surgery = () => (
    <div className="md:flex show-dots">
      <div className="col-20 p-0">
        <div className="card flex justify-content-center py-3 p-0">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"calendar"}
                control={control}
                errors={errors}
                name={"date_of_surgery"}
                label={"Select Date"}
                placeholder={"DD-MM-YYYY"}
                rules={{
                  required: "Surgery Date is required",
                }}
                inputParentClass={"w-full md:pr-3 div_pb-0"}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-20 p-0">
        <div className="card flex justify-content-center py-3 p-0">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"text"}
                control={control}
                errors={errors && "Treated by is required"}
                label="Treated by"
                name={"treated_by"}
                inputParentClass={"w-full md:pr-3 div_pb-0"}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-20 p-0">
        <div className="card flex justify-content-center py-3 p-0">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"dropdown"}
                control={control}
                errors={errors}
                name={"surgery_type"}
                label={"Surgery Type"}
                inputParentClass={"w-full md:pr-3 div_pb-0"}
                options={[
                  {
                    label: "Free",
                    value: "Free",
                  },
                  {
                    label: "Paid",
                    value: "Paid",
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-20 p-0">
        <div className="card flex justify-content-center py-3 p-0">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"dropdown"}
                control={control}
                errors={errors}
                name={"lens_type"}
                label={"Lens Type"}
                inputParentClass={"w-full md:pr-3 div_pb-0"}
                options={[
                  {
                    label: "Free",
                    value: "Free",
                  },
                  {
                    label: "Paid",
                    value: "Paid",
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-20 p-0">
        <div className="card flex justify-content-center py-3">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"text"}
                control={control}
                errors={errors}
                name={"treatment_summary"}
                label={"Summary"}
                inputParentClass={"w-full md:pr-3 div_pb-0"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const init = async () => {
    if (patientVisitId) {
      Promise.all([
        await commonPostApi(API_ENDPOINTS.SEARCH_POST_SURGERY_FOLLOWUP_DETAILS, {
          patient_visit_id: patientVisitId,
        }),
      ]).then(async ([data]) => {
      if (data?.data?.data && !_.isEmpty(data?.data?.data)) {
  const apiData = data?.data?.data;

  setInitialData(apiData); // ⭐ store original data
  setDataExist(true);

  let formattedData = {};

  Object.keys(apiData).forEach((key) => {
    if (["diet_given", "medication_given"].includes(key)) {
      formattedData[key] = apiData[key] === true ? "yes" : "no";
    } else if (apiData[key]?.split?.("T")?.[1] === "00:00:00.000Z") {
      formattedData[key] = new Date(apiData[key]);
    } else {
      formattedData[key] = apiData[key];
    }
  });

  reset(formattedData); // ⭐ IMPORTANT
}
 else {
          ["diet_given", "medication_given"].forEach((item) => {
            setValue(item, "no");
          });
        }
      });
    }
  };

  useEffect(() => {
    init();
  }, []);

  const seventhFollowUp = () => (
    <div className="md:flex show-dots">
      <div className="col-20 p-0">
        <div className="card flex justify-content-center py-3 p-0">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"calendar"}
                control={control}
                errors={errors}
                name={"seventh_day_follow_up"}
                label={"Select Date"}
                placeholder={"DD-MM-YYYY"}
                minDate={
                  watch("date_of_surgery") && addDays(watch("surgery_date"), 1)
                }
                disabled={watch("date_of_surgery") ? false : true}
                inputParentClass={"w-full md:pr-3 div_pb-0"}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-80 p-0">
        <div className="card flex justify-content-center py-3">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"text"}
                control={control}
                errors={errors}
                name={"seventh_day_comments"}
                label={"Comments"}
                inputParentClass={"w-full div_pb-0 md:pr-3"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const fortynthFollowUp = () => (
    <div className="md:flex show-dots">
      <div className="col-20 p-0">
        <div className="card flex justify-content-center py-3 p-0">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"calendar"}
                control={control}
                errors={errors}
                placeholder={"DD-MM-YYYY"}
                name={"fourteenth_day_follow_up"}
                label={"Select Date"}
                disabled={watch("seventh_day_follow_up") ? false : true}
                minDate={
                  watch("seventh_day_follow_up") &&
                  addDays(watch("seventh_day_follow_up"), 1)
                }
                inputParentClass={"w-full md:pr-3 div_pb-0"}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-80 p-0">
        <div className="card flex justify-content-center py-3">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"text"}
                control={control}
                errors={errors}
                name={"fourteenth_comments"}
                label={"Comments"}
                inputParentClass={"w-full div_pb-0 md:pr-3"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const fortythFollowUp = () => (
    <div className="md:flex show-dots">
      <div className="col-20 p-0">
        <div className="card flex justify-content-center py-3 p-0">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"calendar"}
                placeholder={"DD-MM-YYYY"}
                control={control}
                errors={errors}
                name={"fortyth_day_follow_up"}
                label={"Select Date"}
                minDate={
                  watch("fourteenth_day_follow_up") &&
                  addDays(watch("fourteenth_day_follow_up"), 1)
                }
                disabled={watch("fourteenth_day_follow_up") ? false : true}
                inputParentClass={"w-full md:pr-3 div_pb-0"}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-80 p-0">
        <div className="card flex justify-content-center py-3">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"text"}
                control={control}
                errors={errors}
                name={"fortyth_day_comments"}
                label={"Comments"}
                inputParentClass={"w-full div_pb-0 md:pr-3"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const finalStatus = () => (
    <div className="md:flex show-dots">
      <div className="col-20 p-0">
        <div className="card flex justify-content-center py-3 p-0">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"dropdown"}
                control={control}
                errors={errors}
                placeholder={"Select"}
                name={"final_status"}
                label={"Final Status"}
                disabled={watch("fortyth_day_follow_up") ? false : true}
                options={[
                  {
                    label: "Successful",
                    value: "successful",
                  },
                  {
                    label: "UnSuccessful",
                    value: "unsuccessful",
                  },
                ]}
                inputParentClass={"w-full md:pr-3 div_pb-0"}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-80 p-0">
        <div className="card flex justify-content-center py-3">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"text"}
                control={control}
                errors={errors}
                name={"final_status_comments"}
                label={"Comments"}
                inputParentClass={"w-full div_pb-0 md:pr-3"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const MedicationGiven = () => (
    <div className="md:flex show-dots">
      <div className="col-20 p-0 flex align-items-center">
        <div className="card flex justify-content-center py-3 p-0">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputComponent
                type={"radio"}
                name={"medication_given"}
                control={control}
                radioMenu={[
                  {
                    inputId: "yes",
                    name: "medication_given",
                    label: "Yes",
                  },
                  {
                    inputId: "no",
                    name: "medication_given",
                    label: "No",
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-80 p-0">
        <div className="card flex justify-content-center py-3">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"text"}
                control={control}
                errors={errors}
                name={"medicine_details"}
                label={"Comments"}
                inputParentClass={"w-full div_pb-0 md:pr-3"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const DietGiven = () => (
    <div className="md:flex show-dots">
      <div className="col-20 p-0 flex align-items-center">
        <div className="card flex justify-content-center py-3 p-0">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputComponent
                type={"radio"}
                name={"diet_given"}
                control={control}
                radioMenu={[
                  {
                    inputId: "yes",
                    name: "diet_given",
                    label: "Yes",
                  },
                  {
                    inputId: "no",
                    name: "diet_given",
                    label: "No",
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-80 p-0">
        <div className="card flex justify-content-center py-3">
          <div className="w-full">
            <div className="flex w-full placeHolder-primaryBlack">
              <InputPrimaryComponents
                type={"text"}
                control={control}
                errors={errors}
                name={"diet_details"}
                label={"Comments"}
                inputParentClass={"w-full div_pb-0 md:pr-3"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const submitButtons = [
    {
      type: "primarySuccessButton",
      label: "Save Changes",
      class: "md:w-11rem pr-2 w-9rem",
      onClick: handleSubmit(onSubmit),
    },
    {
      type: "secondaryButton",
      label: "Discard",
      class: "w-7rem",
      onClick: () => {
       reset(initialData);
      },
    },
  ];

  return (
    <div>
      <div className="public_sans_500 text-lg text-secondaryTextColor pb-4">
        Post Surgery Follow-Up
      </div>
      <div>
        <StepsComponent
          current={2}
          vertical
          stepList={[
            {
              title: "Surgery",
              description: <div>{surgery()}</div>,
              // icon: "pi pi-fw pi-user",
            },
            {
              title: "7th Day",
              description: <div>{seventhFollowUp()}</div>,
              // icon: "pi pi-fw pi-user",
            },
            {
              title: "14th Day",
              description: <div>{fortynthFollowUp()}</div>,
              // icon: "pi pi-fw pi-user",
            },
            {
              title: "40th Day",
              description: <div>{fortythFollowUp()}</div>,
              // icon: "pi pi-fw pi-user",
            },
            {
              title: "Final Status",
              description: <div>{finalStatus()}</div>,
              // icon: "pi pi-fw pi-user",
            },
            {
              title: "Medication Given",
              description: <div>{MedicationGiven()}</div>,
              // icon: "pi pi-fw pi-user",
            },
            {
              title: "Diet Given",
              description: <div>{DietGiven()}</div>,
              // icon: "pi pi-fw pi-user",
            },
            {
              title: "",
              description: <div>{ }</div>,
              // icon: "pi pi-fw pi-user",
            },
          ]}
        />
      </div>

      <div className="ml-2 pt-6">
        <AddButtonSection
          disabled={Object.keys(dirtyFields).length === 0}
          buttons={submitButtons}
        />
      </div>
      <DevTool control={control} />
    </div>
  );
}
